module.exports = __webpack_public_path__ + "static/media/offer-1.c584ef9d.png";